// extracted by mini-css-extract-plugin
export default {"textarea":"Textarea--textarea--0b85e7","fullBorder":"Textarea--fullBorder--0e66ee"};